import Vue from 'vue';
import VueRouter from 'vue-router';
// import Home from '@/views/dl-web/index.vue';
import Login from '@/views/dl-web/Login/index.vue';
import Detail from '@/views/dl-web/Detail/index.vue';
import DoQuestion from '@/views/dl-web/answerPage/questionLayout.vue';
import Report from '@/views/dl-web/Report/index.vue';
import questionDetail from '@/views/dl-web/Report/questionDetail.vue';

Vue.use(VueRouter);

const routes = [
  // {
  //   path: '/dl-web',
  //   name: 'Home',
  //   component: Home,
  //   meta: {
  //     permission: false,
  //   },
  // },
  {
    path: '/dl-web',
    redirect: '/dl-web/login',
  },
  {
    path: '/dl-web/login',
    name: 'Login',
    component: Login,
    meta: {
      permission: false,
    },
  },
  {
    path: '/dl-web/detail',
    name: 'Detail',
    component: Detail,
    meta: {
      permission: false,
    },
  },
  {
    path: '/dl-web/do/question',
    name: 'DoQuestion',
    component: DoQuestion,
    meta: {
      permission: false,
    },
  },
  {
    path: '/dl-web/question/report',
    name: 'Report',
    component: Report,
    meta: {
      permission: false,
    },
  },
  {
    path: '/dl-web/question/questionDetail',
    name: 'questionDetail',
    component: questionDetail,
    meta: {
      permission: false,
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes,
});

export default router;
